import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="partner-toggle"
export default class extends Controller {
  static targets = ["checkbox", "fields", "ageInput", "genderInput", "genderButton"]

  connect() {
    // Set initial state based on checkbox
    this.toggle()
  }

  toggle() {
    const isChecked = this.checkboxTarget.checked

    if (isChecked) {
      this.enableFields()
    } else {
      this.disableFields()
      this.clearFields()
    }
  }

  enableFields() {
    // Show fields if using hidden toggle
    if (this.hasFieldsTarget) {
      this.fieldsTarget.classList.remove("hidden")
    }

    // Enable age input and remove disabled styling
    if (this.hasAgeInputTarget) {
      this.ageInputTarget.disabled = false
      this.ageInputTarget.required = true
      this.ageInputTarget.classList.remove("bg-base-300")
    }

    // Enable gender inputs and make required
    if (this.hasGenderInputTarget) {
      this.genderInputTargets.forEach(input => {
        input.disabled = false
        input.required = true
      })
    }

    // Enable gender button labels
    if (this.hasGenderButtonTarget) {
      this.genderButtonTargets.forEach(btn => {
        btn.classList.remove("btn-disabled")
        btn.classList.add("has-[:checked]:btn-primary")
      })
    }
  }

  disableFields() {
    // Hide fields if using hidden toggle
    if (this.hasFieldsTarget) {
      this.fieldsTarget.classList.add("hidden")
    }

    // Disable age input and add disabled styling
    if (this.hasAgeInputTarget) {
      this.ageInputTarget.disabled = true
      this.ageInputTarget.required = false
      this.ageInputTarget.classList.add("bg-base-300")
    }

    // Disable gender inputs and remove required
    if (this.hasGenderInputTarget) {
      this.genderInputTargets.forEach(input => {
        input.disabled = true
        input.required = false
      })
    }

    // Disable gender button labels
    if (this.hasGenderButtonTarget) {
      this.genderButtonTargets.forEach(btn => {
        btn.classList.add("btn-disabled")
        btn.classList.remove("has-[:checked]:btn-primary")
      })
    }
  }

  clearFields() {
    // Clear values when hiding
    if (this.hasAgeInputTarget) {
      this.ageInputTarget.value = ""
    }
    if (this.hasGenderInputTarget) {
      this.genderInputTargets.forEach(input => {
        input.checked = false
      })
    }
  }
}
